import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import App from '../components/App.vue';
import Signin from '../components/Signin.vue';
import HATVP from '../components/HATVP.vue';
import Parametres from '../components/Parametre.vue';
import Recherche from '../components/Recherche.vue';
import Reporting from '../components/Reporting.vue';
import Profil from '../components/Profil.vue';
import Ressources from '../components/Ressources.vue';
import Timesheet from '../components/Timesheet.vue';
import Users from '../components/Users.vue';
import Clients from '../components/Clients.vue';
import VModal from 'vue-js-modal';
import auth from '../js/auth.js';
Vue.config.devtools = true;

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VModal, { dialog: true });

Vue.http.headers.common['X-CSRF-TOKEN'] = document.getElementsByName('csrf-token')[0].getAttribute('content');
Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_token');
// Vue.http.options.root = 'http://reporting.anthenor.fr';
// Vue.http.options.root = 'https://reporting.winkstrategies.com';
//  Vue.http.options.root = 'http://reporting.test:8000';
Vue.http.options.root = window.location.origin



var loading = 0;
Vue.http.interceptor.before = function(request, next) {
    loading += 1;
    $('body').addClass('loading');
    next(response => {
        loading -= 1;
        if( loading == 0 ) {
            $('body').removeClass('loading');
        }
    });
};
export default Vue;

export var router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Reporting,
        },
        {
            path: '/reporting',
            name: 'Reporting',
            component: Reporting,
            // beforeEnter: Guard.auth
        },
        {
            path: '/reporting/:info/',
            name: 'Reporting-avec-query-et-partage',
            component: Reporting,
            // beforeEnter: Guard.auth
        },
        {
            path: '/signin',
            name: 'signin',
            component: Signin,
            // beforeEnter: Guard.guest
        },
        {
            path: '/hatvp',
            name: 'HATVP',
            component: HATVP,
            // beforeEnter: Guard.auth
        },
        {
            path: '/hatvp/:idclient/:year/',
            name: 'HATVP-with-query',
            component: HATVP,
            // beforeEnter: Guard.auth
        },
        {
            path: '/parametres',
            name: 'Parametres',
            component: Parametres,
            // beforeEnter: Guard.auth
        },
        {
            path: '/profil',
            name: 'Profil',
            component: Profil,
            // beforeEnter: Guard.auth
        },
        {
            path: '/recherche',
            name: 'Recherche',
            component: Recherche,
            // beforeEnter: Guard.auth
        },
        {
            path: '/recherche/:info',
            name: 'Recherche-avec-query',
            component: Recherche,
            // beforeEnter: Guard.auth
        },
        {
            path: '/ressources',
            name: 'Ressources',
            component: Ressources,
            // beforeEnter: Guard.auth
        },
        {
            path: '/timesheet',
            name: 'Timesheet',
            component: Timesheet,
            // beforeEnter: Guard.auth
        },
        {
            path: '/timesheet/:idclient/:year/:month',
            name: 'Timesheet-from-search',
            component: Timesheet,
            // beforeEnter: Guard.auth
        },
        {
            path: '/users',
            name: 'Users',
            component: Users,
            // beforeEnter: Guard.auth
        },
        {
            path: '/clients',
            name: 'Clients',
            component: Clients,
            // beforeEnter: Guard.auth
        }
    ]
});

router.beforeEach((to, from, next) => {
    if(to.path != '/signin') {
        if(auth.check()) {
            console.log('There is a token, resume. (' + to.path + ')');
            next();
        } else {
            console.log('There is no token, redirect to login. (' + to.path + ')');
            next('signin');
        }
    } else {
        console.log('You\'re on the login page');
        next(); // This is where it should have been
    }
    // next(); - This is in the wrong place
});

function checkToken() {
    return false;
}

let vm = new Vue({
    el: '#app',
    data: {
      client: '',
      reporting: ''
    },
    router: router,
    render: app => app(App),
});



// WEBPACK FOOTER //
// ./assets/js/app.js